module.exports = __webpack_public_path__ + "static/media/Electronic_Chart_Display_and_Information_System_01.b5e609e9.jpg";